import type { PermissionScopeOf } from './permissions';

/**
 * Employee portal permission subjects
 */
export enum EmployeeSubject {
  DASHBOARD = 'dashboard',
  EDUCATION = 'education',
  DOCUMENT = 'document',
  LEAVE = 'leave',
  SALARY = 'salary',
  BANK_DETAIL = 'bank_detail',
  FAMILY_DETAIL = 'family_detail',
  ASSET = 'asset',
  TIMESHEET = 'timesheet',
  FILE_MANAGEMENT = 'file_management',
  PERSONAL_INFORMATION = 'personal_information',
}

/**
 * Employee portal permission scope
 *
 * @example
 * 'document.read' | 'leave.create' | 'salary.read' | ...
 */
export type EmployeePermissionScope = PermissionScopeOf<EmployeeSubject>;
